module.exports = __webpack_public_path__ + "media/images/setting-nav-icon-1da7a9de3e6d8773a700c646e33996d3.svg";